var map = {
	"./1/list-pattern1.svg": 883,
	"./1/list-pattern2.svg": 884,
	"./1/list-pattern3.svg": 885,
	"./1/pattern1.svg": 886,
	"./1/pattern2.svg": 887,
	"./1/pattern3.svg": 888,
	"./10/list-pattern1.svg": 889,
	"./10/list-pattern2.svg": 890,
	"./10/list-pattern3.svg": 891,
	"./10/pattern1.svg": 892,
	"./10/pattern2.svg": 893,
	"./10/pattern3.svg": 894,
	"./11/list-pattern1.svg": 895,
	"./11/list-pattern2.svg": 896,
	"./11/list-pattern3.svg": 897,
	"./11/pattern1.svg": 898,
	"./11/pattern2.svg": 899,
	"./11/pattern3.svg": 900,
	"./2/list-pattern1.svg": 901,
	"./2/list-pattern2.svg": 902,
	"./2/list-pattern3.svg": 903,
	"./2/pattern1.svg": 904,
	"./2/pattern2.svg": 905,
	"./2/pattern3.svg": 906,
	"./3/list-pattern1.svg": 907,
	"./3/list-pattern2.svg": 908,
	"./3/list-pattern3.svg": 909,
	"./3/pattern1.svg": 910,
	"./3/pattern2.svg": 911,
	"./3/pattern3.svg": 912,
	"./4/list-pattern1.svg": 913,
	"./4/list-pattern2.svg": 914,
	"./4/list-pattern3.svg": 915,
	"./4/pattern1.svg": 916,
	"./4/pattern2.svg": 917,
	"./4/pattern3.svg": 918,
	"./5/list-pattern1.svg": 919,
	"./5/list-pattern2.svg": 920,
	"./5/list-pattern3.svg": 921,
	"./5/pattern1.svg": 922,
	"./5/pattern2.svg": 923,
	"./5/pattern3.svg": 924,
	"./6/list-pattern1.svg": 925,
	"./6/list-pattern2.svg": 926,
	"./6/list-pattern3.svg": 927,
	"./6/pattern1.svg": 928,
	"./6/pattern2.svg": 929,
	"./6/pattern3.svg": 930,
	"./7/list-pattern1.svg": 931,
	"./7/list-pattern2.svg": 932,
	"./7/list-pattern3.svg": 933,
	"./7/pattern1.svg": 934,
	"./7/pattern2.svg": 935,
	"./7/pattern3.svg": 936,
	"./8/list-pattern1.svg": 937,
	"./8/list-pattern2.svg": 938,
	"./8/list-pattern3.svg": 939,
	"./8/pattern1.svg": 940,
	"./8/pattern2.svg": 941,
	"./8/pattern3.svg": 942,
	"./9/list-pattern1.svg": 943,
	"./9/list-pattern2.svg": 944,
	"./9/list-pattern3.svg": 945,
	"./9/pattern1.svg": 946,
	"./9/pattern2.svg": 947,
	"./9/pattern3.svg": 948,
	"./99/list-pattern1.svg": 949,
	"./99/pattern1.svg": 950
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 988;